import { createFileRoute } from "@tanstack/react-router";
import { PackageIcon } from "../../components/icons/sidebar-icons";
import { ModulePlaceholder } from "../../components/modules/module-placeholder";

export const Route = createFileRoute("/_app/inventory")({
	component: () => <ModulePlaceholder messageKey="inventory.message" icon={PackageIcon} />,
});
